import { required } from "vuelidate/lib/validators";

export default class PosData {
  descricao = "";
  serial_pos = "";
  username = "";
  password = "";
  modelo = null;
  id_configuracao_pos = null;
  status = true;
  nuts_pay = false;

  constructor({ 
    descricao = "", 
    serial_pos = "", 
    modelo = null, 
    id_configuracao_pos = null, 
    status = true,
    username = "",
    password = "",
    nuts_pay = "",
  }) {
    this.descricao = descricao;
    this.serial_pos = serial_pos;
    this.modelo = modelo;
    this.id_configuracao_pos = id_configuracao_pos;
    this.status = status;
    this.username = username;
    this.password = password;
    this.nuts_pay = nuts_pay;
  }
}

export const PosDataRequired = {
  descricao: {
    required,
  },
  serial_pos: {
    required,
  },
};
